import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasePageComponent } from './components/base-page/base-page.component';
import { EntityPageComponent } from './components/entity-page/entity-page.component';
import { NbButtonModule, NbCardModule, NbTooltipModule } from '@nebular/theme';
import { NTXChartsModule } from '../ntx-charts/ntx-charts.module';
import { TablesModule } from 'src/ntx-app/components/ngx-components/tables/tables.module';
import { LayoutModule } from 'src/ntx-app/components/ngx-components/layout/layout.module';

@NgModule({
  declarations: [
    BasePageComponent,
    EntityPageComponent,
  ],
  imports: [
    CommonModule,
    NbCardModule,
    NTXChartsModule,
    NbButtonModule,
    NbTooltipModule,
    LayoutModule
  ],
  exports: [
    EntityPageComponent
  ]
})
export class PageModule { }
